import React from 'react'
import {Link} from 'react-router-dom'
import CardMiSuscripcion from './Components/CardMiSuscripcion'
import CardFacturasEmitidas from './Components/CardFacturasEmitidas'
import './styles/suscripcion.css'
import CardComprobantes from './Components/CardComprobantes'
import { useSelector } from 'react-redux'
import { State } from '../../reducers'

const Suscripcion = () => {

  const {datos} = useSelector((state: State) => state.userLogin)

  return (
    <>
      <div className='header'>
        <Link to='/home' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Suscripción</h3>
      </div>
      <div className='separador'></div>
      <CardMiSuscripcion />
      <CardFacturasEmitidas />
    </>
  )
}

export default Suscripcion
